import { useEffect } from 'react';
import { signOut } from 'utils/auth';
import { oidcConfig } from 'config';

const Logout = (props) => {
  useEffect(() => {
    signOut(oidcConfig);
  }, []);
  return null;
};

export default Logout;
